import dayjs from "dayjs"


/** True when the sales event starts and ends on the same calendar day. */
export const isSingleDaySalesEvent = (startTimeStamp, endTimeStamp) => {
  if (!startTimeStamp || !endTimeStamp) return true
  return dayjs(startTimeStamp).isSame(dayjs(endTimeStamp), "day")
}

/** Bounds + multi-day flag for date-picker limits (same shape as `saleEventDateBounds` state). */
export const getSaleEventWindowMeta = (startTimeStamp, endTimeStamp) => {
  const multiDay = !isSingleDaySalesEvent(startTimeStamp, endTimeStamp)
  return { start: startTimeStamp, end: endTimeStamp, isMultiDay: multiDay }
}


/**
 * Intersection of the event window [eventStart, eventEnd] with the selected calendar day.
 * Used when the event spans multiple days and the user picks which day the meeting occurred.
 */
export const getMeetingTimeForDayInEvent = (selectedDate, eventStartTs, eventEndTs) => {
  const d0 = dayjs(selectedDate).startOf("day")
  const d1 = dayjs(selectedDate).endOf("day")
  const es = dayjs(eventStartTs)
  const ee = dayjs(eventEndTs)

  let slotStart = es.isBefore(d0) ? d0 : es
  let slotEnd = ee.isAfter(d1) ? d1 : ee

  if (slotStart.isAfter(slotEnd)) {
    return [es, ee.isAfter(es) ? ee : es.add(1, "hour")]
  }
  return [slotStart, slotEnd]
}
